import { alpha, useTheme } from '@mui/material/styles';
import React, { useMemo } from 'react';
import { Bar, BarChart, ResponsiveContainer, XAxis, YAxis } from 'recharts';
import { useSetState } from '../../hooks';

const LEDChart = props => {
    const { width=180, height=320, middleLimit=100, upperLimit=150, prefix="prefix", suffix="suffix", title="Title", unit="Unit", value=50 } = props;
	const theme = useTheme();
	const [state, setState] = useSetState({
		prefixColor: theme.palette.success.light,
		midColor: theme.palette.success.dark,
		suffixColor: theme.palette.error.dark
	});

	const onMouseEnter = () => {
		setState({
			prefixColor: alpha(theme.palette.success.light, 0.9),
			midColor: theme.palette.success.main,
			suffixColor: theme.palette.error.main
		});
	}
	const onMouseLeave = () => {
		setState({
			prefixColor: theme.palette.success.light,
			midColor: theme.palette.success.dark,
			suffixColor: theme.palette.error.dark
		});
	};
	
	const data = useMemo(
		() => [
			{
				[suffix]: upperLimit - middleLimit,
				mid: middleLimit - value,
				[prefix]: value,
				title: title,
				unit: unit
			}
		],
		[suffix, upperLimit, middleLimit, value, prefix, title, unit]
	);


	return (
		<ResponsiveContainer width={width} height={height}>
			<BarChart
				width={width}
				height={height}
				data={data}
				margin={{
					top: 0,
					right: 0,
					left: 0,
					bottom: 0
				}}
				barCategoryGap={0}
				onMouseEnter={onMouseEnter}
				onMouseLeave={onMouseLeave}
			>
				<XAxis dataKey={prefix} />
				<YAxis orientation="right" />

				<Bar dataKey={prefix} stackId="a" fill={state.prefixColor} />
				<Bar dataKey="mid" stackId="a" fill={state.midColor} />
				<Bar dataKey={suffix} stackId="a" fill={state.suffixColor}></Bar>
			</BarChart>
		</ResponsiveContainer>
	);
}

export default LEDChart;